import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { IMetricInfo } from '../../../ts/models/IMetricInfo';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { GreyedOutTextStyle } from '../SpacesStyles';
import { EntityLinkProps } from './Elements/EntityLink';
import { MarkupField } from './Elements/MarkupField';
import { Name } from './Elements/Name';
import { RelatedEntity } from './Elements/RelatedEntity';
import { Tags } from './Elements/Tags';
import { Timestamp } from './Elements/Timestamp';
import { Tooltip } from './Elements/Tooltip';
import { User } from './Elements/User';
import { ContentTooltipProps, getProjectLink, TooltipDescriptionTestId } from './TooltipHelper';

export function MetricTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;

  const owner: IUserInfo = content.owner;

  // workaround for the incompleteness of the original metric content type.
  const description = props.content.description;
  const tags = props.content.tags;

  const connectedView = (props.content as IMetricInfo).connectedView;

  let connectedViewLink: EntityLinkProps;
  if (connectedView) {
    const viewName = connectedView.isViewModified ? connectedView.name + '*' : connectedView.name;
    connectedViewLink = {
      href: urls.viewUrl(connectedView.path),
      iconImagePath: null,
      name: viewName
    };
  } else {
    connectedViewLink = {
      name: Messages.unavailable(),
      textStyleOverride: GreyedOutTextStyle,
      href: '',
      iconImagePath: null
    };
  }

  const projectLink = getProjectLink((props.content as IMetricInfo).project, urls);

  return (
    <Tooltip>
      <Name name={props.content.name} />
      <MarkupField markup={description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <Tags tags={tags} />
      <RelatedEntity label={Messages.metricConnectedView()} link={connectedViewLink}/>
      {!props.inProjectSpace && <RelatedEntity label={Messages.project()} link={projectLink} /> }
      <User user={owner} label={Messages.owner()} urls={urls} />
      {/* "Refreshed": Last time the metric data store gets updated
          "Modified": last time the metric itself was modified */}
      {props.lastUpdatedTimestamp && <Timestamp label={Messages.metricLastUpdated()} value={props.lastUpdatedTimestamp} />}
    </Tooltip>
  );
}
